import React from 'react'
import PropTypes from 'prop-types'
import {Container, Row, Col} from 'react-bootstrap'
import parse from 'html-react-parser';
import { useStaticQuery, graphql, Link } from "gatsby"
import Heading from '../../../components/ui/heading'
import Text from '../../../components/ui/text'
import Button from '../../../components/ui/button'
import Image from '../../../components/image'
import {AssuranceWrap, ImageWrap, CaseStudyTextWrap, ButtonWrap} from './assurance.style'

const Assurance = ({titleStyle, textStyle, product,setFormActive}) => {
    const qdata = useStaticQuery(graphql `
    query CaseQuery3 {
        img: file(relativePath: { eq: "shield.png" }) {
        
            childImageSharp {
              fluid(maxWidth: 922, maxHeight: 760, quality: 100){
                presentationWidth
                presentationHeight
                ...GatsbyImageSharpFluid
              }
            }

        }
    }      
    `);
    //console.log(3434334)
    //console.log(qdata)
    const data = qdata.img;
    const imageFluid = qdata.img.childImageSharp.fluid;

    return (
        <AssuranceWrap>
        <Row>
            <Col>
                  <Heading {...titleStyle}>
                      {/*Vi jobber med alle de vesentligste&raquo;
                      <span>garantiutstederne</span> i markedet*/}
                      <span>Like garantivilkår</span> uavhengig av utsteder
                  </Heading>
                  <Text {...textStyle}>
                      Vilkårene for {product.toLowerCase()}-forsikringer er like uavhengig forsikringsselskap, men
                      de ulike utstederne har ulikt fokus med tanke på egenskapene til kundene og størrelsen
                      på garantiene  de er villige til å utstede.
                      Vi innhenter pris fra de leverandører som er villige til å utstede {product.toLowerCase()}er
                    tilpasset deres bedrifts behov - slik at dere kan sammenligne ulike tilbud på {product.toLowerCase()}er.
                  </Text>
            </Col>

            <Col>
                  <Heading {...titleStyle}>
                      {/*Vi jobber med alle de vesentligste&raquo;
                  <span>garantiutstederne</span> i markedet*/}
                      <span>Solide</span> og <span>godkjente</span> forsikringsselskaper
                  </Heading>
                  <Text {...textStyle}>
                    Vi inkluderer utelukkende solide og godkjente forsikringsselskaper.
                    Tilbyderne av {product.toLowerCase()} i denne tjenesten er kun
                    selskaper som har blitt godkjent av de største aktørene i bransjen.
                  </Text>
                  <ButtonWrap>
                      <Button onClick={()=>{setFormActive(true)}}>Sammenlign tilbud på {product.toLowerCase()}er &raquo;</Button>
                  </ButtonWrap>
            </Col>

        </Row>
        </AssuranceWrap>
    )
}

Assurance.propTypes = {
    titleStyle: PropTypes.object
}

Assurance.defaultProps = {
    titleStyle: {
        as:"h3",
        child: {
            color: 'primary'
        }
    },
    textStyle: {
        mt: '30px'
    }
}

export default Assurance;
